export const MARKETING_CONTEXT_STALE = 5 * 60 * 1000
